import Vue from 'vue';

Vue.filter('minutesToHours', (minutes: number) => {
  if (!minutes) return '';
  minutes = minutes / 60;

  const sign = minutes < 0 ? '-' : '';
  const hours = Math.floor(Math.abs(minutes));
  const min = Math.floor((Math.abs(minutes) * 60) % 60);

  let result = sign + hours;
  result += ':' + (min < 10 || min === 0 ? '0' : '') + min;

  return result;
});
